import React, { useState } from 'react';
import { Button, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Close, InfoOutlined } from '@mui/icons-material';

export default function () {
    const [open, setOpen] = useState(false);
    const [currentVersion, setCurrentVersion] = useState(process.env.REACT_APP_VERSION);

    useQuery({
        enabled: !window.location.hostname.includes('localhost'),
        queryKey: ['app-version'],
        queryFn: async () =>
            fetch('/version.txt', { cache: 'no-store' })
                .then((res) => res.text())
                .then((text) => text.trim())
                .catch(() => null),
        refetchInterval: 60000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
        onSuccess: (version) => {
            if (typeof version !== 'string' || !version) return;
            if (currentVersion !== version) {
                setOpen(true);
                // Dismiss until another new version is available
                setCurrentVersion(version);
            }
        },
    });

    return (
        <Drawer variant="persistent" open={open} anchor="top">
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    width: '100vw',
                    minHeight: '64px',
                    height: '100%',
                    bgcolor: (theme) => theme.palette.primary.dark,
                    color: (theme) => theme.palette.primary.contrastText,
                    paddingX: 2,
                }}
                // wrap
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    <InfoOutlined sx={{ fontSize: 25 }} />
                    <Typography fontSize={15}>
                        <b>A new version is available.</b> Refresh your browser to get the latest updates and improvements.
                    </Typography>
                </Stack>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            window.location.reload();
                        }}
                        sx={{ color: (theme) => theme.palette.primary.contrastText, borderColor: (theme) => theme.palette.primary.contrastText }}
                    >
                        refresh
                    </Button>
                    <IconButton
                        sx={{
                            color: (theme) => theme.palette.primary.contrastText,
                        }}
                        onClick={() => setOpen(false)}
                    >
                        <Close fontSize="large" />
                    </IconButton>
                </Stack>
            </Stack>
        </Drawer>
    );
}
